import ConfirmationDialog from 'components/ConfirmationDialog'
import { ModalInjectedProps } from 'containers/ModalManager'
import React from 'react'
import { useShareRestoreWithUi } from './useShareRestoreWithUi'

export interface RestoreShareModalProps extends ModalInjectedProps {
  name: string
  shareIdentifier: string
  isInDraftsProject?: boolean
}

export const RestoreShareModal: React.FC<RestoreShareModalProps> = props => {
  const {
    name,
    hideModal,
    shareIdentifier,
    isModalOpen,
    isInDraftsProject,
  } = props

  const [restoreShare, { loading }] = useShareRestoreWithUi({
    identifier: shareIdentifier,
    onCompleted: () => {
      hideModal()
    },
  })

  const restoreCopy = isInDraftsProject ? (
    <>
      Restoring “<strong>{name}</strong>” from Trash will move it back to My
      Drafts.
    </>
  ) : (
    <>
      Restoring “<strong>{name}</strong>” from Trash will move it back to the
      All Documents view and any Project it was in.
    </>
  )

  return (
    <ConfirmationDialog
      title="Restore Document?"
      isModalOpen={isModalOpen}
      hideModal={hideModal}
      cancelButton={{
        disabled: loading,
        text: 'Cancel',
      }}
      confirmButton={{
        text: 'Restore Document',
        variant: 'primary',
        loading,
        disabled: loading,
      }}
      onConfirm={restoreShare}>
      <p>{restoreCopy}</p>
    </ConfirmationDialog>
  )
}
